<template>
  <div v-loading="tableLoading">
    <el-divider content-position="left">Modbus</el-divider>
    <el-button type="primary" size="mini" @click="addCollection">添加</el-button>
    <el-table :data="tableList" style="width: 100%;margin-top: 10px;">
      <el-table-column prop="name" label="名称" width="120"></el-table-column>
      <el-table-column prop="dev_addr" width="180" label="设备地址"></el-table-column>
      <el-table-column prop="interval" width="100" label="采集周期"></el-table-column>
      <el-table-column prop="slaveid" label="从站ID" width="100"></el-table-column>
      <el-table-column prop="function" label="功能码" width="100"></el-table-column>
      <el-table-column prop="start" label="起始地址" width="120"></el-table-column>
      <el-table-column prop="size" label="数据长度" width="80"></el-table-column>
      <el-table-column prop="datatype" label="数据类型" width="120"></el-table-column>
      <el-table-column prop="endian" label="字节序" width="120"></el-table-column>
      <el-table-column prop="factor" label="计算因子" width="80"></el-table-column>
      <el-table-column prop="data" label="采集结果" width="200"></el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row, 'daqcmd')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-divider content-position="left">西门子S7</el-divider>
    <el-button type="primary" size="mini" @click="addS7Data">添加</el-button>
    <el-table :data="s7Data">
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="dev_addr" label="设备地址"></el-table-column>
      <el-table-column prop="start" label="起始地址"></el-table-column>
      <el-table-column prop="rack" label="机架号"></el-table-column>
      <el-table-column prop="slot" label="槽位"></el-table-column>
      <el-table-column prop="area" label="地址域"></el-table-column>
      <el-table-column prop="dbnum" label="DB号"></el-table-column>
      <el-table-column prop="datatype" label="数据类型"></el-table-column>
      <el-table-column prop="size" label="数据长度"></el-table-column>
      <el-table-column prop="endian" label="字节序"></el-table-column>
      <el-table-column prop="factor" label="计算因子"></el-table-column>
      <el-table-column prop="data" label="采集结果"></el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEditS7(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row, 's7cmd')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-divider content-position="left">
      {{ $t('lang.editVar.msg26') }}</el-divider>

    <el-table :data="customTableList" style="width: 100%;margin-top: 10px;">
      <el-table-column prop="name" label="名称" width="120">
        <template slot-scope="scope">
          <el-input v-model="scope.row.name" size="mini"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="interval" label="采集周期">
        <template slot-scope="scope">
          <el-input v-model="scope.row.interval" size="mini"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="指令类型">
        <template slot-scope="scope">
          <!-- <el-input v-model="scope.row.type" size="mini"></el-input> -->
          <el-select v-model="scope.row.type" size="mini">
            <el-option label="16进制" value="HEX"></el-option>
            <el-option label="ASCII码" value="ASCII"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="cmd" label="采集指令">
        <template slot-scope="scope">
          <el-input v-model="scope.row.cmd" size="mini"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="return_flag" label="回车换行">
        <template slot-scope="scope">
          <!-- <el-input v-model="scope.row.return_flag" size="mini"></el-input> -->
          <el-checkbox v-model="scope.row.return_flag"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="deleteRow(scope.row, scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" @click="addRow" size="mini">新增</el-button>
    <el-button type="primary" size="mini" style="margin: 10px auto;display: flex;align-items: center;"
      @click="saveTap">保存并应用</el-button>
    <modbus ref="modbusdialog" @update="updateModbus" :deviceDid="deviceDid" :deviceSn="deviceSn"></modbus>
    <ss ref="s7dialog" @update="updateS7" :deviceDid="deviceDid" :deviceSn="deviceSn"></ss>
  </div>
</template>

<script>
import { listConfig, updateConfig } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import { cloneDeep } from "lodash"
import modbus from "./dialog/modbus.vue";
import ss from "./dialog/ss.vue";
export default {
  name: "",
  props: ['deviceDid', 'deviceSn'],
  data() {
    return {
      tableList: [],
      dialogVisible: false,
      dialogTitle: '新增',
      tableLoading: false,
      formLoadng: false,
      currentIndex: undefined,
      functionCode: {
        '1': '1（读线圈）',
        '2': '2（读输入状态）',
        '3': '3（读保持寄存器）',
        '4': '4（读输入寄存器)'
      },
      dataTypeList: ['int16', 'uint16', 'int32', 'uint32', 'int64', 'uint64', 'float', 'double', 'bool', 'string', 'raw'],
      customTableList: [],
      s7Data: []
    };
  },
  methods: {
    async getData() {
      this.tableLoading = true
      try {
        const res = await listConfig(this.deviceSn, this.deviceDid, [
          {
            config: 'modbus',
            section: 'daqcmd',
            options: [
              {
                option: "name"
              },
              {
                option: 'dev_addr'
              },
              {
                option: 'interval'
              },
              {
                option: 'slaveid'
              },
              {
                option: 'function'
              },
              {
                option: 'start'
              },
              {
                option: 'datatype'
              },
              {
                option: 'size'
              },
              {
                option: 'endian'
              },
              {
                option: 'factor'
              },
              {
                option: 'bind_dev',
              },
              {
                option: 'only_write',
              },
              {
                option: 'buff_cmd',
              },
            ]
          }
        ])
        if (res.data.data.mess === '') {
          this.tableLoading = false
          return
        }
        this.tableList = res.data.data.mess[0].s_objects.map(item => {
          return {
            index: item.index,
            sname: item.sname,
            ...item.options,
          }
        })
      } catch (err) {
        this.$message.error('操作失败')
        this.tableLoading = false
        return
      }
      try {
        const res2 = await listConfig(this.deviceSn, this.deviceDid, [
          {
            config: 'modbus',
            section: 'cmd',
            options: [
              {
                option: "name"
              },
              {
                option: "interval"
              },
              {
                option: "type"
              },
              {
                option: "cmd"
              },
              {
                option: "return_flag"
              },
            ]
          }
        ])
        this.customTableList = res2.data.data.mess[0].s_objects.map(item => {
          return {
            ...item.options,
            index: item.index,
            sname: item.sname,
            return_flag: item.options.return_flag == 1
          }
        })
      } catch {
        this.$message.error('操作失败')
        this.tableLoading = false
        return
      }
      try {
        const res3 = await listConfig(this.deviceSn, this.deviceDid, [
          {
            "section": "s7cmd",
            "config": "modbus",
            options: [
              {
                option: "name"
              },
              {
                option: 'dev_addr'
              },
              {
                option: 'start'
              },
              {
                option: 'datatype'
              },
              {
                option: 'size'
              },
              {
                option: 'endian'
              },
              {
                option: 'factor'
              },
              {
                option: 'bind_dev',
              },
              {
                option: 'rack',
              },
              {
                option: 'slot',
              },
              {
                option: 'area',
              },
              {
                option: 'dbnum',
              },
            ]
          }
        ])
        this.s7Data = res3.data.data.mess[0].s_objects.map((item) => {
          return {
            index: item.index,
            sname: item.sname,
            ...item.options,
            bind_dev: item.options.bind_dev == '1',
          }
        })
      } catch {
        this.$message.error('操作失败')
        this.tableLoading = false
        return
      }
      this.tableLoading = false
    },
    handleEdit(row) {
      this.$refs.modbusdialog.dialogVisible = true
      this.$refs.modbusdialog.currentData = row
    },
    handleEditS7(row) {
      this.$refs.s7dialog.dialogVisible = true
      this.$refs.s7dialog.currentData = row
    },
    handleDelete(row, section) {
      this.$confirm('此操作将删除该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.tableLoading = true
        const res = await updateConfig(this.deviceSn, this.deviceDid, [
          {
            config: 'modbus',
            section,
            action: 2,
            index: [row.index],
          }
        ])
        if (res.data.data.mess == 0) {
          this.$message.success('操作成功')
        } else {
          this.$message.error('操作失败')
        }
        this.getData()
      })
    },
    handleClose() {
      this.currentData = {
        name: '',
        dev_addr: 'COM1',
        interval: '5',
        slaveid: '',
        function: 1,
        start: '',
        datatype: '',
        size: '',
        precise: '3'
      }
      this.currentIndex = undefined
    },
    addCollection() {
      this.$refs.modbusdialog.dialogVisible = true
    },
    addS7Data() {
      this.$refs.s7dialog.dialogVisible = true
    },
    confirmAdd() {
      this.formLoadng = true
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await updateConfig(this.deviceSn, this.deviceDid, [
            {
              config: 'modbus',
              section: 'daqcmd',
              action: this.currentData.sname == undefined ? 1 : 0,
              index: this.currentData.sname == undefined ? [this.tableList.length] : [this.currentData.index],
              sname: this.currentData.sname == undefined ? this.currentData.name : undefined,
              options: {
                ...this.currentData,
                index: undefined,
                sname: undefined
              }
            }
          ])
          if (res.data.data.mess == 0) {
            this.$message.success(this.dialogTitle + '成功')
          } else {
            this.$message.error(this.dialogTitle + '失败')
          }
          this.formLoadng = false
          this.dialogVisible = false
          this.getData()
        } else {
          this.$message.error('请填写完整')
          this.formLoadng = false
        }
      })
    },
    async saveTap() {
      this.tableLoading = true
      let data = [];
      this.customTableList.forEach((item, index) => {
        data.push({
          config: 'modbus',
          section: 'cmd',
          action: item.sname == undefined ? 1 : 0,
          index: item.sname == undefined ? [index] : [item.index],
          sname: item.sname == undefined ? item.name : undefined,
          options: {
            ...item,
            index: undefined,
            sname: undefined,
            return_flag: item.return_flag ? 1 : 0
          },
          server: 'smartlink'
        })
      })
      const res = await updateConfig(this.deviceSn, this.deviceDid, data)
      if (res.data.data.mess == 0) {
        this.$message.success('操作成功')
      } else {
        this.$message.error('操作失败')
      }
      this.tableLoading = false
    },
    deleteRow(row, index) {
      this.$confirm('此操作将删除该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.tableLoading = true;
        if (row.index === undefined) {
          this.customTableList.splice(index, 1)
          this.tableLoading = false;
          return
        }
        const res = await updateConfig(this.deviceSn, this.deviceDid, [
          {
            config: 'modbus',
            section: 'cmd',
            action: 2,
            index: [row.index],
          }
        ])
        if (res.data.data.mess == 0) {
          this.$message.success('操作成功')
        } else {
          this.$message.error('操作失败')
        }
        this.getData()
      })
    },
    addRow() {
      this.customTableList.push({
        name: '',
        interval: '',
        type: 'HEX',
        cmd: '',
        return_flag: false
      })
    },
    async updateModbus(d) {
      try {
        const resp = await updateConfig(this.deviceSn, this.deviceDid, [
          {
            config: 'modbus',
            section: 'daqcmd',
            action: d.sname === undefined ? 1 : 0,
            index: d.sname === undefined ? [this.tableList.length] : [d.index],
            sname: d.sname == undefined ? d.name : undefined,
            server: 'smartlink',
            options: {
              ...d,
              index: undefined,
              sname: undefined,
              bind_dev: d.bind_dev ? '1' : '0',
              only_write: d.only_write ? '1' : '0',
              buff_cmd: d.buff_cmd ? '1' : '0',
            }
          }
        ])
        if (resp.data.data.mess == 0) {
          this.$message.success('操作成功')
          this.$refs.modbusdialog.dialogVisible = false;
          this.$refs.modbusdialog.currentData = {
            name: '',
            dev_addr: '',
            interval: '5',
            slaveid: '',
            function: '1',
            start: '',
            datatype: '',
            size: '',
            precise: '',
            factor: '',
            sname: undefined,
            index: undefined,
            bind_dev: false,
            endian: 'ABCD',
            only_write: false,
            buff_cmd: false
          }
        } else {
          this.$message.error('操作失败')
        }
      } catch {
        this.$message.error('操作失败')
      }
    },
    async updateS7(d) {
      try {
        const resp = await updateConfig(this.deviceSn, this.deviceDid, [
          {
            config: 'modbus',
            section: 's7cmd',
            action: d.sname === undefined ? 1 : 0,
            index: d.sname == undefined ? [this.s7Data.length] : [d.index],
            sname: d.sname == undefined ? d.name : undefined,
            options: {
              ...d,
              index: undefined,
              sname: undefined,
              bind_dev: d.bind_dev ? '1' : '0',
            }
          }
        ])
        if (resp.data.data.mess == 0) {
          this.$message.success('操作成功')
          this.$refs.s7dialog.dialogVisible = false;
          this.$refs.s7dialog.currentData = {
            name: '',
            dev_addr: '',
            start: '',
            datatype: 'bool',
            size: '',
            precise: '',
            factor: '',
            sname: undefined,
            index: undefined,
            bind_dev: false,
            endian: 'ABCD',
            rack: '0',
            area: 'DB',
            dbnum: '0',
            slot: '0'
          }
        } else {
          this.$message.error('操作失败')
        }
      } catch {
        this.$message.error('操作失败')
      }
    }
  },
  created() {
    this.getData()
  },
  components: {
    modbus,
    ss
  },
};
</script>
<style scoped>
.tips {
  color: #999;
  font-size: 12px;
}
</style>